@if (state$ | async; as state) {
    @if (!(inspectedAsset$ | async)) {
        <div #root class="outer" [hidden]="hidden" (dragover)="(false)" (dragend)="(false)">
            <div
                class="flex column align-space-evenly justify-stretch"
                (dragover)="(false)"
                (dragend)="(false)"
            >
                @if (state.viewingAsset) {
                    @if (itemCount === 1) {
                        <div class="flex column align-center justify-center inner" (drop)="drop($event, false, false, state.viewingAsset)">
                            <h1><mat-icon>cloud_upload</mat-icon> Upload New Version</h1>
                        </div>
                    } @else {
                        <div class="flex column align-center justify-center inner warn" (drop)="cancelDrop($event)">
                            <h1><mat-icon>cloud_off</mat-icon> Cannot Upload</h1>
                            <p>Upload only one file for a new version</p>
                        </div>
                    }
                } @else if (state.reviewAsset) {
                    <div class="flex column align-center justify-center inner" (drop)="drop($event, false, false, null, state.reviewAsset)">
                        <h1><mat-icon>cloud_upload</mat-icon> Upload</h1>
                    </div>
                    <div class="flex column align-center justify-center alt-drop inner" (drop)="drop($event, false, true, null, state.reviewAsset)">
                        <h1><mat-icon>cloud</mat-icon> Upload+</h1>
                    </div>
                } @else {
                    <div class="flex column align-center justify-center inner" (drop)="drop($event, false, false)">
                        <h1><mat-icon>cloud_upload</mat-icon> Upload</h1>
                    </div>
                    <div class="flex column align-center justify-center alt-drop inner" (drop)="drop($event, false, true)">
                        <h1><mat-icon>cloud</mat-icon> Upload+</h1>
                    </div>
                    @if (itemCount > 1 && !state.viewingAsset) {
                        <div class="flex column align-center justify-center alt-drop inner" (drop)="drop($event, true, false)">
                            <h1><mat-icon>cloud_circle</mat-icon> Upload &amp; Group</h1>
                        </div>
                    }
                }
            </div>
        </div>
    }
}
